export const BACKEND_TOKEN_KEY = 'backendToken'
export const SUPPORT_SESSION_KEY = 'supportSession'

export const REGISTRATION_STATUS = Object.freeze({
  PROFILE_PENDING: 'PROFILE_PENDING',
  EMAIL_VERIFICATION_PENDING: 'EMAIL_VERIFICATION_PENDING',
  ORGANIZATION_PENDING: 'ORGANIZATION_PENDING',
  COMPLETED: 'COMPLETED'
})

const knownRegistrationStatuses = new Set(Object.values(REGISTRATION_STATUS))

export const getStoredBackendToken = () => {
  if (typeof window === 'undefined') return null
  return window.sessionStorage.getItem(BACKEND_TOKEN_KEY)
}

export const storeBackendToken = token => {
  if (typeof window === 'undefined' || !token) return

  window.sessionStorage.setItem(BACKEND_TOKEN_KEY, token)
  window.localStorage.removeItem('backendToken')
  window.localStorage.removeItem('backendTokenPersist')
}

export const clearStoredBackendToken = () => {
  if (typeof window === 'undefined') return

  window.sessionStorage.removeItem(BACKEND_TOKEN_KEY)
  window.localStorage.removeItem('backendToken')
  window.localStorage.removeItem('backendTokenPersist')
}

export const isSupportSession = () => {
  if (typeof window === 'undefined') return false
  return window.sessionStorage.getItem(SUPPORT_SESSION_KEY) === 'true'
}

export const startSupportSession = () => {
  if (typeof window === 'undefined') return
  window.sessionStorage.setItem(SUPPORT_SESSION_KEY, 'true')
}

export const clearSupportSession = () => {
  if (typeof window === 'undefined') return
  window.sessionStorage.removeItem(SUPPORT_SESSION_KEY)
}

export const resolveRegistrationStatus = (data, fallback = null) => {
  const backendStatus = data?.registrationStatus

  if (knownRegistrationStatuses.has(backendStatus)) {
    return backendStatus
  }

  if (data?.paso === 0) return REGISTRATION_STATUS.PROFILE_PENDING
  if (data?.paso === 1) return REGISTRATION_STATUS.ORGANIZATION_PENDING
  if (data?.token) return fallback || REGISTRATION_STATUS.COMPLETED

  return fallback
}

export const getRegistrationPath = registrationStatus => {
  switch (registrationStatus) {
    case REGISTRATION_STATUS.PROFILE_PENDING:
      return '/auth/signup?step=profile'
    case REGISTRATION_STATUS.EMAIL_VERIFICATION_PENDING:
      return '/auth/signup?step=verification'
    case REGISTRATION_STATUS.ORGANIZATION_PENDING:
      return '/auth/signup?step=organization'
    case REGISTRATION_STATUS.COMPLETED:
      return '/'
    default:
      return '/auth/signin'
  }
}
